export function getCookie(name: string): string {
  const encoded = encodeURIComponent(name);
  const parts = document.cookie ? document.cookie.split(";") : [];
  for (const raw of parts) {
    const part = raw.trim();
    if (part.startsWith(`${encoded}=`)) {
      return decodeURIComponent(part.slice(encoded.length + 1));
    }
    if (part.startsWith(`${name}=`)) {
      return decodeURIComponent(part.slice(name.length + 1));
    }
  }
  return "";
}

export function getCsrfToken(): string {
  return getCookie("csrf_token");
}
